import { Path, PathCodec } from "@pomle/paths";
import { useHistory } from "@pomle/react-router-paths";
import { useEffect, useRef } from "react";

// The view stack keeps a step mounted for a second after it is left, so its
// Back button, or a timer of its own, can still fire. Only the step on screen
// goes back, and only once until that navigation lands, or the flow goes back
// past the screen the step was opened from.
export function useStepBack(): (
  path: Pick<Path<PathCodec>, "match">
) => () => void {
  const { go } = useHistory();
  const pending = useRef(false);

  useEffect(() => {
    function settle() {
      pending.current = false;
    }
    window.addEventListener("popstate", settle);
    return () => {
      window.removeEventListener("popstate", settle);
    };
  }, []);

  return function backFrom(path) {
    return () => {
      // Read at call time: a step held by the view stack keeps the props it
      // was last rendered with, from when it was still on screen.
      if (pending.current || path.match(window.location.pathname) !== 0) {
        return;
      }
      pending.current = true;
      go(-1);
    };
  };
}
